import React from 'react';
import { View, createStyleSheet, useStyleSheet, Focusable, User, Text, Icon, useThemeContext, Divider, Link as UILink, Illustration, IconButton } from '@gopeerproject/ui-kit';
import capitalize from 'lodash/capitalize';
export const Selector = ({ style, onClose, switchProfile, minimized, onViewProfile, onEditProfile, onViewReferrals, onEditAccount, onLogout, onHelp, onManageProfiles, profile, profiles }) => {
    const styles = useStyleSheet(getStyles);
    const { size } = useThemeContext();
    return (React.createElement(View, { style: [
            styles.container,
            !minimized ? styles.container__lg : styles.container__md,
            style
        ] },
        onViewReferrals && (React.createElement(React.Fragment, null,
            React.createElement(View, { style: styles.referrals },
                React.createElement(View, null,
                    React.createElement(Text, { type: 'headline', size: 'md' }, "Referrals"),
                    React.createElement(Text, { type: 'body', size: 'sm', weight: 'regular', style: styles.referralsSubtitle }, "Invite friends and earn rewards"),
                    React.createElement(UILink, { type: 'primary', text: 'Go to referrals', onPress: () => {
                            onClose();
                            onViewReferrals();
                        } })),
                React.createElement(Illustration, { name: 'gift' })),
            React.createElement(Divider, { type: 'horizontal', style: styles.divider }))),
        onViewProfile && (React.createElement(React.Fragment, null,
            React.createElement(Focusable, { style: styles.item, hoverStyle: styles.hover, key: profile.id, onPress: () => {
                    onViewProfile(profile.id);
                } },
                React.createElement(User, { size: 'md', type: profile.type, name: profile.name, image: profile.image }),
                React.createElement(View, { style: styles.itemInfo },
                    React.createElement(Text, { type: 'headline', size: 'md' }, profile.name.split(' ')[0]),
                    React.createElement(Text, { type: 'body', size: 'sm', weight: 'regular', style: styles.itemSubTitle }, "View profile")),
                React.createElement(IconButton, { value: 'copy', type: 'secondary', accent: 'neutral', size: 'sm', onPress: () => {
                        void navigator.clipboard.writeText(`https://app.gopeer.org/tutors/${profile.id}`);
                    } })),
            React.createElement(Divider, { type: 'horizontal', style: styles.divider }))),
        profiles
            .filter(({ id }) => profile.id !== id)
            .map((profile) => (React.createElement(Focusable, { style: styles.item, hoverStyle: styles.hover, key: profile.id, onPress: () => {
                onClose();
                switchProfile(profile);
            } },
            React.createElement(User, { size: 'md', type: profile.type, name: profile.name, image: profile.image }),
            React.createElement(View, { style: styles.itemInfo },
                React.createElement(Text, { type: 'headline', size: 'md' }, profile.name),
                React.createElement(Text, { type: 'body', size: 'sm', weight: 'regular', style: styles.itemSubTitle }, capitalize(profile.type))),
            profile.locked && (React.createElement(Icon, { name: 'lock-closed', size: size.I, color: (color) => color.invert2.p100 }))))),
        profiles.length > 1 && (React.createElement(Divider, { type: 'horizontal', style: styles.divider })),
        onEditProfile && (React.createElement(Focusable, { style: styles.item, hoverStyle: styles.hover, onPress: () => {
                onClose();
                onEditProfile();
            } },
            React.createElement(Icon, { name: 'person', size: 21 }),
            React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.itemActionText }, "My profile"))),
        onManageProfiles && (React.createElement(React.Fragment, null,
            React.createElement(Focusable, { style: styles.item, hoverStyle: styles.hover, onPress: () => {
                    onClose();
                    onManageProfiles();
                } },
                React.createElement(Icon, { name: 'people-settings', size: 21 }),
                React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.itemActionText }, "Manage profiles")))),
        onEditAccount && (React.createElement(Focusable, { style: styles.item, hoverStyle: styles.hover, onPress: () => {
                onClose();
                onEditAccount();
            } },
            React.createElement(Icon, { name: 'settings', size: 21 }),
            React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.itemActionText }, "Account settings"))),
        React.createElement(Divider, { type: 'horizontal', style: styles.divider }),
        React.createElement(Focusable, { style: styles.item, hoverStyle: styles.hover, onPress: () => {
                onClose();
                onHelp();
            } },
            React.createElement(Icon, { name: 'chat-help', size: 21 }),
            React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.itemActionText }, "Help")),
        React.createElement(Focusable, { style: styles.item, hoverStyle: styles.hover, onPress: () => {
                onLogout();
            } },
            React.createElement(Icon, { name: 'sign-out', size: 21 }),
            React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.itemActionText }, "Log out"))));
};
const getStyles = createStyleSheet(({ size, color, colorScheme }) => ({
    container: {
        padding: size.C,
        backgroundColor: color.bg.v3,
        boxShadow: '0px 8px 42px rgba(28, 29, 40, 0.1)',
        borderRadius: size.E
    },
    container__lg: {
        width: '100%'
    },
    container__md: {
        width: 260
    },
    hover: {
        backgroundColor: color.invert2.p4
    },
    item: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: size.E,
        borderRadius: size.C
    },
    itemInfo: {
        marginLeft: size.C,
        flex: 1
    },
    itemSubTitle: {
        color: color.invert2.p56,
        marginTop: size.A
    },
    divider: {
        marginVertical: size.C,
        marginHorizontal: size.E
    },
    itemActionText: {
        fontWeight: '500',
        marginLeft: size.C
    },
    referrals: {
        padding: size.G,
        borderRadius: size.D,
        borderColor: color.invert2.p4,
        borderWidth: 1,
        backgroundImage: colorScheme === 'dark'
            ? 'linear-gradient(221.63deg, rgba(116, 182, 254, 0.15) 23.53%, rgba(255, 221, 189, 0.15) 100%)'
            : 'linear-gradient(221.63deg, #EEF5FD 23.53%, #F7F5F2 100%)',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    referralsSubtitle: {
        marginTop: size.B,
        color: color.invert2.p56,
        width: 128,
        marginBottom: size.C
    }
}));
//# sourceMappingURL=Selector.js.map